import React, { useEffect } from "react";
import "./About.css";

/* IMPORT HEADER */

import Header from "../Header/Header";

/* IMPORT IMAGES */

import aboutImage from "../../uploads/fidin img pdf_page-0004.jpg";

import aboutExtraImage from "../../uploads/fidin img pdf_page-0003.jpg";

import visionImage from "../../uploads/fidin img pdf_page-0006.jpg";

import missionImage from "../../uploads/fidin img pdf_page-0007.jpg";

const About = () => {

  useEffect(() => {

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0px)";
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const elements = document.querySelectorAll(
      ".about-image, .about-content, .value-card, .value-image"
    );

    elements.forEach((el) => {

      el.style.opacity = "0";
      el.style.transform = "translateY(40px)";
      el.style.transition = "all 1s ease";

      observer.observe(el);
    });

    return () => observer.disconnect();

  }, []);

  return (

    <div className="about-page">

      {/* HEADER */}

      <Header />

      {/* HERO SECTION */}

<section className="hero">

        <h1>About FIDIN Group</h1>

        <p>
          Building Excellence Since 2010
        </p>

      </section>

      {/* ABOUT SECTION */}

      <section className="about">

        <div className="about-container">

          {/* LEFT IMAGE */}

          <div className="about-image">

            <img
              src={aboutImage}
              alt="Our Team"
            />

          </div>

          {/* RIGHT CONTENT */}

          <div className="about-content">

            <h2>Who We Are</h2>

            <p>
              FIDIN Ventures is an emerging infrastructure
              and energy solutions company focused on
              delivering high-quality engineering projects
              across India.

              We specialize in renewable energy,
              transmission systems, and industrial EPC
              projects, combining technical expertise
              with strong execution capabilities.
            </p>

            <div className="about-extra-image">

              <img
                src={aboutExtraImage}
                alt="FIDIN"
              />

            </div>

            <a href="#contact" className="btn">
              Get In Touch
            </a>

          </div>

        </div>

      </section>

      {/* VALUES SECTION */}

      <section className="values">

        <div className="values-container">

          <h2 className="values-title">
            Our Core Values
          </h2>

          <div className="values-grid">

            {/* VISION IMAGE */}

            <div className="value-image">

              <img
                src={visionImage}
                alt="Vision"
              />

            </div>

            {/* VISION */}

            <div className="value-card">

              <h3>Vision</h3>

              <p>
                To become a leading infrastructure
                and energy solutions company driving
                sustainable growth in India.
              </p>

            </div>

            {/* MISSION IMAGE */}

            <div className="value-image">

              <img
                src={missionImage}
                alt="Mission"
              />

            </div>

            {/* MISSION */}

            <div className="value-card">

              <h3>Mission</h3>

              <p>
                To deliver reliable, efficient,
                and high-quality engineering
                solutions that create long-term value.
              </p>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default About;